<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Zoneamentos</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <a-row>
                        <a-col :span="2">
                            <strong>Descrição</strong>
                        </a-col>
                        <a-col :span="10">
                            <a-space>
                                <a-input v-model:value="currentZone.description" style="width: 30vw"/>
                            </a-space>
                        </a-col>

                        <a-col :span="2">
                            <strong>Objetivo</strong>
                        </a-col>
                        <a-col :span="10">
                            <a-space>
                                <a-input v-model:value="currentZone.objective" style="width: 30vw"/>
                            </a-space>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-button
                            style="margin: 0 auto; margin-top: 30px"
                            @click="saveZone"
                            :disabled="currentZone.objective === '' || currentZone.description === ''"
                        >
                            Salvar
                        </a-button>
                    </a-row>

                    <br><br>

                    <a-table :columns="columns" :data-source="dataSource" bordered>
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.dataIndex === 'data'">
                                {{ new Date(record.data).toLocaleDateString('pt-BR', {timeZone: 'UTC'}) }}
                            </template>
                            <template v-if="column.key === 'acao'">
                                <a-tooltip title="Alterar">
                                    <a-button type="primary" class="center-flex" shape="circle"
                                              @click="update(record)">
                                        <template #icon>
                                            <FormOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip title="Excluir">
                                    <a-button type="primary"
                                              class="center-flex"
                                              danger
                                              shape="circle"
                                              @click="destroy(record)"
                                    >
                                        <template #icon>
                                            <DeleteOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </template>
                        </template>
                    </a-table>
                </a-card>
            </a-config-provider>
        </a-spin>
    </div>
</template>
<script setup>
import {ref, onMounted} from 'vue';
import {FormOutlined, DeleteOutlined} from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import {notification} from 'ant-design-vue';
import { openNotification } from '../../../../utils/utilities';

const dataSource = ref();
const currentLocale = ref(ptBR);
const spinning = ref(true);

const route = '/api/viabilidade/zoneamentos';


const currentZone = ref({
    id: null,
    description: '',
    objective: ''
})

const columns = ref(
    [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 150,
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Objetivo',
            dataIndex: 'objective',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ]
);


onMounted(async () => {
    await load();
});


const saveZone = async () => {
    let {id, ...data} = currentZone.value
    if (!id) {
        try {
            spinning.value = true
            const response = await window.axios.post(route, data)
            spinning.value = false
            openNotification('success', response.data.message)
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    } else {
        try {
            spinning.value = true
            const response = await window.axios.put(route + `/${id}`, data)
            spinning.value = false
            openNotification('success', response.data.message)
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }
    await load()
}

const load = async () => {
    currentZone.value.id = null
    currentZone.value.description = ''
    currentZone.value.objective = ''
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
}


const destroy = async (data) => {
    try {
        const response = await window.axios.delete(route + `/${data.id}`);
        openNotification('success', response.data.message)
        load();
    } catch (error) {
        openNotification('error', error.message)
    }
}

const update = (data) => {
    currentZone.value.id = data.id
    currentZone.value.description = data.description
    currentZone.value.objective = data.objective
}
</script>

<style scoped>
.center-flex {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.anticon {
    vertical-align: 2px !important;
}
</style>
